import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import StatusDropdown from "./statusOptions";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { CiEdit } from 'react-icons/ci';
import { FaRegEye } from "react-icons/fa";
import { TiTickOutline } from "react-icons/ti";
import { CiLocationArrow1 } from "react-icons/ci";
import { MdOutlineDangerous } from "react-icons/md";
import { MdOutlineAssignmentInd } from "react-icons/md";
import ToastNotification from '../../../../components/ToastNotification';


const VendorCallStatusPage = ({ adminData ,branchID,financialYear }) => {
    const navigate = useNavigate();
    const { status } = useParams();
    const readable = status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase());


    const [search, setSearch] = useState("");
    const [complaints, setComplaints] = useState([]);
    const [branchDetail, setBranchDetail] = useState([])
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const [showFollowupModal, setShowFollowupModal] = useState(false);
    const [followupRow, setFollowupRow] = useState(null);
    const [nextFollowupDate, setNextFollowupDate] = useState("");
    const [followupStatus, setFollowupStatus] = useState("");
    const [totalAmount, setTotalAmount] = useState(0);
    const [rechargeList, setRechargeList] = useState([])
    const [actionStatus, setActionStatus] = useState("");
    const [showStatusModal, setShowStatusModal] = useState(false);
     const [callList, setCallList] = useState([]);


    const [statusForm, setStatusForm] = useState({
        remark: "",
        date: "",
        emp_id: adminData?.user?.emp_id || ""
    });

    const [followupForm, setFollowupForm] = useState({
  remark: "",
  date: "",
  emp_id: adminData?.user?.emp_id || "",
  next_followup_date: ""
});

  const limit = 20;
    const [offset, setOffset] = useState(0);
                    const [hasMore, setHasMore] = useState(true);
                    const [fromDate, setFromDate] = useState();
                    const [toDate, setToDate] = useState();
     const [isLocked, setIsLocked] = useState(false);
     const [fy, setFy] = useState([]);
                  
    const [financialRange, setFinancialRange] = useState({
     from_date: '',
     to_date: ''
 });


    const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success'
    });

    const showToast = (message, bg = 'success') => {
        setToast({ show: true, message, bg });
    };


    const tableConfig = {
        new: {
            headers: ["Action", "Ref Doc", , "Date", "Party", "Address", "Item ", "Service Charge", "Remark"],
            rows: complaints.filter(c => c.call_status === "new")
        },
        accepted: {
            headers: ["View", "Action", "Ref Doc", "Date", "Party", "Contact", "Address", "Item ","Service Charge", "Remark"],
            rows: complaints.filter(c => c.call_status === "accepted")
        },
        followup: {
            headers: ["View", "Action", "Ref Doc", "Date", "Party", "Contact", "Address", "Item ", "Next Followup","Service Charge", "Remark"],
            rows: complaints.filter(c => c.call_status === "followup")
        },
        "denied-pending": {
            headers: ["View", "Ref Doc", "Date", "Party", "Contact", "Address", "Item ","Service Charge", "Remarks"],
            rows: complaints.filter(c => c.call_status === "denied-pending")
        },
        "denied-approved": {
            headers: ["View", "Ref Doc", "Date", "Party", "Contact", "Address", "Item ","Service Charge", "Remarks"],
            rows: complaints.filter(c => c.call_status === "denied-approved")
        },
        "denied-rejected": {
            headers: ["View", "Ref Doc", "Date", "Party", "Contact", "Address", "Item ","Service Charge", "Remarks"],
            rows: complaints.filter(c => c.call_status === "denied-rejected")
        },
        completed: {
            headers: ["View", "Ref Doc", "Date", "Party", "Contact", "Address", "Item ","Service Charge", "Remark"],
            rows: complaints.filter(c => c.call_status === "completed")
        },
        "re-complaint": {
            headers: ["View", "Ref Doc", "Date", "Party", "Contact", "Address", "Item ","Service Charge", "Remark"],
            rows: complaints.filter(c => c.status === "RE-COMPLAINT")
        }
    };

    const config = tableConfig[status];

   

    const filteredRows =
        config?.rows.filter(row =>
            Object.values(row).some(val =>
                String(val).toLowerCase().includes(search.toLowerCase())
            )
        ) || [];



    const fetchComplaints = async (fromDate,
    toDate,
    branchCode,
    newOffset = 0) => {

      if (!branchCode) {
      console.log("Branch code missing");
      return;
    }

    try {
        const res = await axios.get("https://api.skyguard.group/api/fetch-complaint",
             {
          params: {
            from_date: fromDate,
            to_date: toDate,
            branchId: branchCode,
            limit: limit,
            offset: newOffset
          }
        }
        );

     
        const filtered = res.data.filter(row => row.complaint_type === "OC Call");

        const getLatestDate = (row) => {
            try {
                const obj = JSON.parse(row.call_status_date || "{}");
                const dates = Object.values(obj).map(v =>
                    typeof v === "string" ? v : v?.date
                );

                return dates.length
                    ? new Date(Math.max(...dates.map(d => new Date(d))))
                    : new Date(row.date);

            } catch {
                return new Date(row.date);
            }
        };

        filtered.sort((a, b) => getLatestDate(b) - getLatestDate(a));


        // setComplaints(filtered);
     const result = filtered;
      if (newOffset === 0) {
       setComplaints(result);
        setHasMore(true);
      }

      else {
        setComplaints(prev => {
          const merged = [...prev, ...result];

          // optional: remove duplicates (safety)
          const unique = Array.from(
            new Map(merged.map(item => [item.id, item])).values()
          );

          return unique;
        });
      }

      if (result.length < limit) {
        setHasMore(false);
      }


    } catch (err) {
        console.error(err);
    }
};



  const fetchBranchDetail = async () => {
   
        try {
            const branchRes = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
            setBranchDetail(branchRes.data)
            
            return branchRes.data.code;
        } catch (error) {
            console.log(error)
        } 
    };

      const fetchYearDetail = async () => {
                                 
                try {
                                        const branchCode = await fetchBranchDetail();
                                     
                                        const res = await axios.get(
                                            `https://api.skyguard.group/api/fetch-financial-year-localData/${financialYear}`
                                        );
                                        const yearData = res.data;
                                        setFy(yearData);
                                        setIsLocked(yearData.is_locked === 1);
                                        setFinancialRange({
                                            from_date: yearData.from_date,
                                            to_date: yearData.to_date
                                        });
                            
                                        await fetchComplaints(
                                            yearData.from_date,
                                            yearData.to_date,
                                            branchCode,
                            
                                        );
                                    } catch (error) {
                                        console.log(error);
                                    } 
                                };


    useEffect(() => {
        // fetchComplaints();
        fetchYearDetail ();
        fetchBranchDetail();

    }, [])

    const renderItemNames = (items) => {
        if (!items) return "-";

        try {
            const parsedItems = JSON.parse(items); 

            return parsedItems.map((item, index) => (
                <div key={index}>
                    {item.name}
                </div>
            ));
        } catch (error) {
            console.error("Invalid items JSON", error);
            return "Invalid item data";
        }
    };

    const getItemNamesString = (items) => {
        if (!items) return "";

        try {
            const parsedItems = JSON.parse(items);
            return parsedItems.map(item => item.name).join(", ");
        } catch (error) {
            console.error("Invalid items JSON", error);
            return "";
        }
    };


    const handleView = (row) => {
        setSelectedRow(row);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedRow(null);
    };


    const handleSubmitNew = async (id, status) => {
  try {
    await axios.put(
      "https://api.skyguard.group/api/update-call-status-to-accepetd",
      {
        id,
        status,
        emp_id: adminData?.user.emp_id 
      }
    );

    showToast("Call Status updated Successfully", "success");
    fetchComplaints();
  } catch (err) {
    console.error(err);
    showToast("Call Update failed", "danger");
  }
};

    const handleSubmit = async () => {
        try {
            const callRemarkHistory = {
                remark: statusForm.remark,
                date: statusForm.date,
                emp_id: statusForm.emp_id || adminData?.user.emp_id  
            };

            await axios.put("https://api.skyguard.group/api/update-call-status", {
                id: selectedRow.id,
                status: actionStatus,
                call_remark_history: callRemarkHistory   
            });

            showToast("Call Status updated Successfully", "success");


            setStatusForm({ remark: "", date: "", emp_id: "" });
            // setShowFollowupModal(false);
            setShowStatusModal(false);
            
            setNextFollowupDate("");

            fetchComplaints();
        } catch (err) {
            console.error(err);
            showToast("Call Update failed", "danger");
        }
    };

   
const submitFollowup = async () => {
  if (!followupForm.next_followup_date) {
    showToast("Please select follow up date", "error");
    return;
  }

  try {
    const callRemarkHistory = {
      remark: followupForm.remark,
      date: followupForm.date,
      emp_id: followupForm.emp_id
    };

    await axios.post("https://api.skyguard.group/api/add-complaint-followup", {
      id: followupRow.id,
      call_status: "followup",
      next_followup_date: followupForm.next_followup_date,
      call_remark_history: callRemarkHistory   // ✅ send JSON
    });

    showToast("Follow up created successfully", "success");

    setShowFollowupModal(false);

    setFollowupForm({
      remark: "",
      date: "",
      emp_id: adminData?.user?.emp_id || "",
      next_followup_date: ""
    });

    fetchComplaints();

  } catch (error) {
    console.error(error);
    showToast("Failed to create follow up", "error");
  }
};

    const handleDenied = async (id, status) => {
        try {
            const res = await axios.put(
                "https://api.skyguard.group/api/handle-denied-call",
                {
                    id: id,
                    status: status
                },
                {
                    headers: { "Content-Type": "application/json" }
                }
            );


            showToast("Call Denied  Successfully", "success");
        } catch (error) {
            console.error(error);
            showToast("Failed To deny the call", "danger");
        }
    };

    const getRemarkText = (remarks) => {
        try {
            if (!remarks) return "";

            // If remarks is JSON string
            if (typeof remarks === "string" && remarks.trim().startsWith("{")) {
                const parsed = JSON.parse(remarks);
                return parsed?.remarks || "";
            }

            // If remarks is already an object
            if (typeof remarks === "object") {
                return remarks?.remarks || "";
            }

            // Plain string
            return remarks;
        } catch (err) {
            return "";
        }
    };


 
const formatStatusHistory = (call_status_date) => {
    if (!call_status_date) return "";

    try {
        const obj =
            typeof call_status_date === "string"
                ? JSON.parse(call_status_date)
                : call_status_date;

        return Object.entries(obj)
            .map(([status, value]) => {
                // handle both old + new structure
                const date = typeof value === "string" ? value : value?.date;
                const emp_id = typeof value === "object" ? value?.emp_id : null;

                const formattedDate = date
                    ? new Date(date).toLocaleString()
                    : "N/A";

                return `${status.toUpperCase()} : ${formattedDate} ${
                    emp_id ? `(EMP: ${emp_id})` : ""
                }`;
            })
            .join("\n");
    } catch (err) {
        return "";
    }
};


    const formatCallRemarkHistory = (call_remark_history) => {
        if (!call_remark_history) return "";

        try {
            const data =
                typeof call_remark_history === "string"
                    ? JSON.parse(call_remark_history)
                    : call_remark_history;

            if (!Array.isArray(data)) return "";

            return data
                .map(
                    (item, index) =>
                        `${index + 1}. ${item.remark} | ${item.date}  | ${item.emp_id}`
                )
                .join("\n");
        } catch (err) {
            console.error("Parse error:", err);
            return "";
        }
    };

    useEffect(() => {
        fetchRecharge();
    }, [])

    const fetchRecharge = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-recharge');

            setRechargeList(res.data);

            if (res.data.length > 0) {
                const latest = res.data[res.data.length - 1];
                setTotalAmount(Number(latest.totalAmount || 0));

            }

        } catch (error) {
            console.error(error);
        }
    };

 const handleLoadMore = () => {

    const nextOffset = offset + limit;
    setOffset(nextOffset);

    fetchComplaints(
      financialRange.from_date,
      financialRange.to_date,
      branchDetail.code,
      nextOffset
    );
  };

    return (
        <div className='main-section'>
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                <ToastNotification
                    show={toast.show}
                    message={toast.message}
                    bg={toast.bg}
                    onClose={() => setToast({ ...toast, show: false })}
                />

                <h3 className='my-3 fw-bold fs-5 golos'>Vendor Call – {readable}</h3>


                <div className="mb-3 row gx-1 gy-1 align-items-center d-flex justify-content-end">
                    <div className="col-12 col-md-2 d-flex justify-content-end">
                        <button className="btn btn-primary">
                            Total Balance: ₹{totalAmount}
                        </button>
                    </div>
                </div>





                <div className="row gx-4 gy-2 align-items-center">

                    <div className="col-md-6">
                        <label className="form-label fw-medium">Search</label>
                        <input
                            type="text"
                            className="form-control border-0 border-bottom border-dark"
                            placeholder="Search..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>

                    <div className="col-md-6 justify-content-end">
                        <label className="form-label fw-medium">Select Status</label>
                        <StatusDropdown current={status} />
                    </div>
                </div>

                <hr />



                <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                    <table className="table table-bordered table-striped text-center table-sm align-middle">
                        <thead className="table-info">
                            <tr>

                                {config.headers.map(h => (
                                    <th key={h}>{h}</th>
                                ))}
                            </tr>
                        </thead>

                        <tbody>
                            {config.rows.map(row => (
                                <tr key={row.id}>

                                    {status === "new" && (
                                        <>
                                            <td className="cursor-pointer"
                                                style={{ display: "flex", alignItems: "center", justifyContent: 'space-around' }}>
                                                <FaRegEye
                                                    size={26}
                                                    className="ms-1 text-primary"
                                                    style={{ cursor: "pointer" }}
                                                    title="View"
                                                    onClick={() => handleView(row)}
                                                />
                                                <CiLocationArrow1
                                                    size={26}
                                                    className="ms-1 text-success"
                                                    style={{ cursor: "pointer" }}
                                                    title="Accepted"
                                                    onClick={() => handleSubmitNew(row.id, "accepted")}
                                                 
                                                />
                                            </td>
                                            <td>{`CMP/${row.branch}/${row.ref_doc}/${fy.financial_year.split('-')[0]}`}</td>
                                            <td>{row.date} </td>
                                            <td>{row.party_name}</td>
                                            <td>{row.party_state || ''}, {row.party_city || ''},{row.party_region || ""},{row.party_pincode || ''}  </td>
                                            <td>{renderItemNames(row.items)}</td>
                                            <td>{row.franchisee_cost} </td>
                                            <td>
                                                {(() => {
                                                    try {

                                                        const r = typeof row.remarks === "string" ? JSON.parse(row.remarks) : row.remarks;
                                                        return r?.remarks || "";
                                                    } catch (err) {
                                                        return row.remarks || "";
                                                    }
                                                })()}
                                            </td>
                                        </>
                                    )}

                                    {status === "accepted" && (
                                        <>
                                            <td> <FaRegEye
                                                size={26}
                                                className="ms-1 text-primary"
                                                style={{ cursor: "pointer" }}
                                                title="View"
                                                onClick={() => handleView(row)}
                                            /> </td>

                                            <td className="cursor-pointer"
                                                style={{ display: "flex", alignItems: "center", justifyContent: 'space-around' }}>

                                                <CiLocationArrow1
                                                    size={26}
                                                    className="ms-1 text-dark"
                                                    style={{ cursor: "pointer" }}
                                                    title="Follow Up"
                                                    // onClick={() => handleSubmit(row.id, "followup")}

                                                    onClick={() => {
                                                        setFollowupRow(row);
                                                        setActionStatus("followup");

                                                        // setShowFollowupModal(true);
                                                          setShowStatusModal(true);
                                                        setSelectedRow(row)
                                                    }}
                                                />
                                                <MdOutlineAssignmentInd
                                                    size={26}
                                                    className="ms-1 text-info"
                                                    style={{ cursor: "pointer" }}
                                                    title="Assign"

                                                    onClick={() => navigate("/admin/crm/complaint", {

                                                        state: {

                                                            mode: "showForm",
                                                            partyId: row.id,

                                                        },

                                                    })}

                                                />
                                                <MdOutlineDangerous
                                                    size={26}
                                                    className="ms-1 text-danger"
                                                    style={{ cursor: "pointer" }}
                                                    title="Denied"
                                                    // onClick={() => handleSubmit(row.id, "denied-pending")}

                                                                onClick={() => {
                                                        setFollowupRow(row);
                                                        setActionStatus("denied-pending");

                                                        // setShowFollowupModal(true);
                                                          setShowStatusModal(true);
                                                        setSelectedRow(row)
                                                    }}
                                                />
                                            </td>


                                            <td>{`CMP/${row.branch}/${row.ref_doc}/${fy.financial_year.split('-')[0]}`}</td>
                                            <td>{row.date} </td>
                                            <td>{row.party_name}</td>
                                            <td>{row.party_phone} {row.party_mobile} {row.party_phone_two} {row.party_phone_three}  </td>
                                           <td>{row.party_state || ''}, {row.party_city || ''},{row.party_region || ""},{row.party_pincode || ''}  </td>
                                           

                                            <td>{renderItemNames(row.items)}</td>

                                        <td>{row.franchisee_cost} </td>
                                            <td>
                                                {(() => {
                                                    try {

                                                        const r = typeof row.remarks === "string" ? JSON.parse(row.remarks) : row.remarks;
                                                        return r?.remarks || "";
                                                    } catch (err) {
                                                        return row.remarks || "";
                                                    }
                                                })()}
                                            </td>
                                        </>
                                    )}

                                    {status === "followup" && (
                                        <>

                                            <td> <FaRegEye
                                                size={26}
                                                className="ms-1 text-primary"
                                                style={{ cursor: "pointer" }}
                                                title="View"
                                                onClick={() => handleView(row)}
                                            /> </td>

                                            <td className="cursor-pointer"
                                                style={{ display: "flex", alignItems: "center", justifyContent: 'space-around' }}>

                                                <CiLocationArrow1
                                                    size={26}
                                                    className="ms-1 text-dark"
                                                    style={{ cursor: "pointer" }}
                                                    title="Follow Up"

                                                    // onClick={() => {
                                                    //     setFollowupRow(row);
                                                    //     setFollowupStatus(row.status);
                                                    //     setShowFollowupModal(true);
                                                    // }}

                                                    onClick={() => {
  setFollowupRow(row);
  setShowFollowupModal(true);
}}
                                                    
                                                />
                                                <MdOutlineAssignmentInd
                                                    size={26}
                                                    className="ms-1 text-info"
                                                    style={{ cursor: "pointer" }}
                                                    title="Assign"

                                                    onClick={() => navigate("/admin/crm/complaint", {

                                                        state: {

                                                            mode: "showForm",
                                                            partyId: row.id,

                                                        },

                                                    })}

                                                />
                                                <MdOutlineDangerous
                                                    size={26}
                                                    className="ms-1 text-danger"
                                                    style={{ cursor: "pointer" }}
                                                    title="Denied"
                                                    // onClick={() => handleSubmit(row.id, "denied-pending")}
                                                            onClick={() => {
                                                        setFollowupRow(row);
                                                        setActionStatus("denied-pending");

                                                        // setShowFollowupModal(true);
                                                          setShowStatusModal(true);
                                                        setSelectedRow(row)
                                                    }}
                                                />
                                            </td>
                                            <td>{`CMP/${row.branch}/${row.ref_doc}/${fy.financial_year.split('-')[0]}`}</td>
                                            <td>{row.date} </td>
                                            <td>{row.party_name}</td>
                                            <td>{row.party_phone} {row.party_mobile} {row.party_phone_two} {row.party_phone_three}  </td>
                                          <td>{row.party_state || ''}, {row.party_city || ''},{row.party_region || ""},{row.party_pincode || ''}  </td>

                                            <td>{renderItemNames(row.items)}</td>


                                    

                                            <td>{row.next_followup_date} </td>

                                              <td>{row.franchisee_cost} </td>
                                            <td>
                                                {(() => {
                                                    try {

                                                        const r = typeof row.remarks === "string" ? JSON.parse(row.remarks) : row.remarks;
                                                        return r?.remarks || "";
                                                    } catch (err) {
                                                        return row.remarks || "";
                                                    }
                                                })()}
                                            </td>
                                        </>
                                    )}

                                    {status === "denied-pending" && (
                                        <>

                                            <td> <FaRegEye
                                                size={26}
                                                className="ms-1 text-primary"
                                                style={{ cursor: "pointer" }}
                                                title="View"
                                                onClick={() => handleView(row)}
                                            /> </td>
                                            <td>{`CMP/${row.branch}/${row.ref_doc}/${fy.financial_year.split('-')[0]}`}</td>
                                            <td>{row.date} </td>
                                            <td>{row.party_name}</td>
                                            <td>{row.party_phone} {row.party_mobile} {row.party_phone_two} {row.party_phone_three}  </td>
                                           <td>{row.party_state || ''}, {row.party_city || ''},{row.party_region || ""},{row.party_pincode || ''}  </td>

                                            <td>{renderItemNames(row.items)}</td>

                                              <td>{row.franchisee_cost} </td>


                                            <td>
                                                {(() => {
                                                    try {

                                                        const r = typeof row.remarks === "string" ? JSON.parse(row.remarks) : row.remarks;
                                                        return r?.remarks || "";
                                                    } catch (err) {
                                                        return row.remarks || "";
                                                    }
                                                })()}
                                            </td>
                                        </>
                                    )}


                                    {status === "denied-approved" && (
                                        <>

                                            <td> <FaRegEye
                                                size={26}
                                                className="ms-1 text-primary"
                                                style={{ cursor: "pointer" }}
                                                title="View"
                                                onClick={() => handleView(row)}
                                            /> </td>

                                            <td>{`CMP/${row.branch}/${row.ref_doc}/${fy.financial_year.split('-')[0]}`}</td>
                                            <td>{row.date} </td>
                                            <td>{row.party_name}</td>
                                            <td>{row.party_phone} {row.party_mobile} {row.party_phone_two} {row.party_phone_three}  </td>
                                           <td>{row.party_state || ''}, {row.party_city || ''},{row.party_region || ""},{row.party_pincode || ''}  </td>

                                            <td>{renderItemNames(row.items)}</td>

                                              <td>{row.franchisee_cost} </td>

                                            <td>
                                                {(() => {
                                                    try {

                                                        const r = typeof row.remarks === "string" ? JSON.parse(row.remarks) : row.remarks;
                                                        return r?.remarks || "";
                                                    } catch (err) {
                                                        return row.remarks || "";
                                                    }
                                                })()}
                                            </td>
                                        </>
                                    )}

                                    {status === "denied-rejected" && (
                                        <>
                                            <td> <FaRegEye
                                                size={26}
                                                className="ms-1 text-primary"
                                                style={{ cursor: "pointer" }}
                                                title="View"
                                                onClick={() => handleView(row)}
                                            /> </td>
                                            <td>{`CMP/${row.branch}/${row.ref_doc}/${fy.financial_year.split('-')[0]}`}</td>
                                            <td>{row.date} </td>
                                            <td>{row.party_name}</td>
                                            <td>{row.party_phone} {row.party_mobile} {row.party_phone_two} {row.party_phone_three}  </td>
                                            <td>{row.party_state || ''}, {row.party_city || ''},{row.party_region || ""},{row.party_pincode || ''}  </td>

                                            <td>{renderItemNames(row.items)}</td>
                                               <td>{row.franchisee_cost} </td>

                                            <td>
                                                {(() => {
                                                    try {

                                                        const r = typeof row.remarks === "string" ? JSON.parse(row.remarks) : row.remarks;
                                                        return r?.remarks || "";
                                                    } catch (err) {
                                                        return row.remarks || "";
                                                    }
                                                })()}
                                            </td>
                                        </>
                                    )}

                                    {status === "completed" && (
                                        <>
                                            <td> <FaRegEye
                                                size={26}
                                                className="ms-1 text-primary"
                                                style={{ cursor: "pointer" }}
                                                title="View"
                                                onClick={() => handleView(row)}
                                            /> </td>
                                            <td>{`CMP/${row.branch}/${row.ref_doc}/${fy.financial_year.split('-')[0]}`}</td>
                                            <td>{row.date} </td>
                                            <td>{row.party_name}</td>
                                            <td>{row.party_phone} {row.party_mobile} {row.party_phone_two} {row.party_phone_three}  </td>
                                            <td>{row.party_state || ''}, {row.party_city || ''},{row.party_region || ""},{row.party_pincode || ''}  </td>

                                            <td>{renderItemNames(row.items)}</td>

                                              <td>{row.franchisee_cost} </td>


                                            <td>
                                                {(() => {
                                                    try {

                                                        const r = typeof row.remarks === "string" ? JSON.parse(row.remarks) : row.remarks;
                                                        return r?.remarks || "";
                                                    } catch (err) {
                                                        return row.remarks || "";
                                                    }
                                                })()}
                                            </td>
                                        </>
                                    )}

                                    {status === "re-complaint" && (
                                        <>
                                            <td> <FaRegEye
                                                size={26}
                                                className="ms-1 text-primary"
                                                style={{ cursor: "pointer" }}
                                                title="View"
                                                onClick={() => handleView(row)}
                                            /> </td>
                                            <td>{`CMP/${row.branch}/${row.ref_doc}/${fy.financial_year.split('-')[0]}`}</td>
                                            <td>{row.date} </td>
                                            <td>{row.party_name}</td>
                                            <td>{row.party_phone} {row.party_mobile} {row.party_phone_two} {row.party_phone_three}  </td>
                                         <td>{row.party_state || ''}, {row.party_city || ''},{row.party_region || ""},{row.party_pincode || ''}  </td>

                                            <td>{renderItemNames(row.items)}</td>

                                              <td>{row.franchisee_cost} </td>


                                            <td>
                                                {(() => {
                                                    try {

                                                        const r = typeof row.remarks === "string" ? JSON.parse(row.remarks) : row.remarks;
                                                        return r?.remarks || "";
                                                    } catch (err) {
                                                        return row.remarks || "";
                                                    }
                                                })()}
                                            </td>

                                        </>
                                    )}


                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>


                {showModal && (
                    <div className="modal fade show d-block" tabIndex="-1">
                        <div className="modal-dialog modal-md modal-dialog-centered">
                            <div className="modal-content">

                                {/* Header */}
                                <div className="modal-header">
                                    <h5 className="modal-title text-success">Complaint Details</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={closeModal}
                                    ></button>
                                </div>

                                {/* Body */}
                                <div className="modal-body">

                                    <div className="row g-2">
                                        <div className="col-6">
                                            <label className="form-label fw-medium text-primary">Doc </label>
                                            <input className="form-control" value={`CMP/${selectedRow?.branch}/${selectedRow?.ref_doc}`} />
                                        </div>

                                        <div className="col-6">
                                            <label className="form-label fw-medium text-primary ">Date  </label>
                                            <input className="form-control" value={selectedRow.date} />
                                        </div>

                                        <div className="col-6">
                                            <label className="form-label fw-medium text-primary ">Party </label>
                                            <input className="form-control" value={selectedRow.party_name} />
                                        </div>

                                        <div className="col-6">
                                            <label className="form-label fw-medium text-primary ">Party Address  </label>
                                            <input className="form-control" value={selectedRow.party_address} />
                                        </div>
                                        <div className="col-6">
                                            <label className="form-label fw-medium text-primary ">Item </label>
                                            <input
                                                className="form-control"
                                                rows={3}
                                                value={getItemNamesString(selectedRow?.items)}
                                                readOnly
                                            />

                                        </div>

                                        <div className="col-6">
                                            <label className="form-label fw-medium text-primary ">Remark  </label>
                                            <textarea className="form-control" value={getRemarkText(selectedRow.remarks)} />
                                        </div>


                                        <div className="col-12">
                                            <label className="form-label fw-medium text-primary">
                                                Date History
                                            </label>

                                            <textarea
                                                className="form-control"
                                                rows={3}
                                                readOnly
                                                value={formatStatusHistory(selectedRow?.call_status_date)}
                                            />
                                        </div>

                                        <div className="col-12">
                                            <label className="form-label fw-medium text-primary">
                                                Remark History
                                            </label>
                                            <textarea
                                                className="form-control"
                                                rows={3}
                                                readOnly
                                                value={formatCallRemarkHistory(selectedRow?.call_remark_history)}
                                            />

                                        </div>


                                    </div>


                                </div>

                                {/* Footer */}
                                <div className="modal-footer">
                                    <button
                                        className="btn btn-info"
                                        onClick={closeModal}
                                    >
                                        Close
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                )}


                {showStatusModal && (
                    <div className="modal show d-block mt-4" style={{ background: "rgba(0,0,0,0.4)" }}>
                        <div className="modal-dialog ">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h6 className="modal-title">Add Remark</h6>
                                    <button
                                        className="btn-close"
                                        onClick={() => setShowStatusModal(false)}
                                    />
                                </div>

                                {/* <div className="modal-body">
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={nextFollowupDate}
                                        onChange={(e) => setNextFollowupDate(e.target.value)}
                                    />
                                </div> */}

                                <div className="modal-body">
                                    <label className="form-label fw-medium text-primary">Remark</label>
                                    <textarea
                                        className="form-control"
                                        value={statusForm.remark}
                                        onChange={(e) =>
                                            setStatusForm({ ...statusForm, remark: e.target.value })
                                        }
                                    />
                                </div>


                                <div className="modal-body">
                                    <label className="form-label fw-medium text-primary">Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={statusForm.date}
                                        onChange={(e) =>
                                            setStatusForm({ ...statusForm, date: e.target.value })
                                        }
                                    />
                                </div>

                                {/* <div className="modal-body">
  <label className="form-label fw-medium text-primary">Employee ID</label>
  <input
    type="text"
    className="form-control"
    value={statusForm.emp_id}
    // onChange={(e) =>
    //   setStatusForm({ ...statusForm, emp_id: e.target.value })
    // }
    readOnly
  />
</div> */}

                                <div className="modal-footer">
                                    {/* <button
                                        className="btn btn-primary btn-sm"
                                        onClick={submitFollowup}
                                    >
                                        Save
                                    </button> */}
                                    <button className="btn btn-success" onClick={handleSubmit}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}



                {showFollowupModal && (
  <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.4)" }}>
    <div className="modal-dialog modal-md modal-dialog-centered">
      <div className="modal-content">

        <div className="modal-header">
          <h5 className="modal-title text-primary">Follow Up</h5>
          <button className="btn-close" onClick={() => setShowFollowupModal(false)} />
        </div>

        <div className="modal-body">
          <label>Remark</label>
          <textarea
            className="form-control"
            value={followupForm.remark}
            onChange={(e) =>
              setFollowupForm({ ...followupForm, remark: e.target.value })
            }
          />
        </div>

        <div className="modal-body">
          <label>Date Of Remark</label>
          <input
            type="date"
            className="form-control"
            value={followupForm.date}
            onChange={(e) =>
              setFollowupForm({ ...followupForm, date: e.target.value })
            }
          />
        </div>

        <div className="modal-body">
          <label>Next Follow Up Date</label>
          <input
            type="date"
            className="form-control"
            value={followupForm.next_followup_date}
            onChange={(e) =>
              setFollowupForm({
                ...followupForm,
                next_followup_date: e.target.value
              })
            }
          />
        </div>


        <div className="modal-footer">
          <button className="btn btn-success" onClick={submitFollowup}>
            Submit
          </button>
        </div>

      </div>
    </div>
  </div>
)}


  {hasMore && (
              <div className="text-center mt-3">
                <button
                  className="btn btn-primary"
                  onClick={handleLoadMore}
                >
                  Load More
                </button>
              </div>
            )}

            </div>
        </div>
    );
};

export default VendorCallStatusPage;
